import React from 'react';
import Facebook from '../icons/Facebook'
import Linkedin from '../icons/Linkedin'
import Twitter from '../icons/Twitter'


export const navlinks=[
    {
     icon:<Facebook />,
     url:"https://www.facebook.com",
     name:"facebook"
    },
    {
        icon:<Linkedin />,
        url:"https://www.linkedin.com",
        name:"Linkeding"
    },
    {
        icon:<Twitter />,
        url:"https://www.twitter.com",
        name:"Twitter"
    }
]